import {
  Card,
  CardContent,
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import InfoPopper from "../popper/InfoPopper";
import { isScope3Open } from "../../config/config";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EmissionData } from "../../models/Emission";
import Group from "../../models/Group";
import { common, overview } from "../../i18n";
// 🌟 เปลี่ยนมาเรียกใช้จากไฟล์หลักที่ไม่มี V2
import EmissionByBusinessGroup, {
  LowToHigh,
  highToLow,
} from "./EmissionByBusinessGroup";

export const scopes: Group[] =
  isScope3Open
    ? [
        {
          id: "Scope-1",
          title: "Scope-1",
          colors: ["var(--blue-25)", "var(--blue)"],
        },
        {
          id: "Scope-2",
          title: "Scope-2",
          colors: ["var(--red-25)", "var(--red)"],
        },
        {
          id: "Scope-3",
          title: "Scope-3",
          colors: ["var(--yellow-25)", "var(--yellow)"],
        },
        {
          id: "Outside-of-Scope",
          title: "Outside-of-Scope",
          colors: ["var(--Outside-of-Scope-25)", "var(--Outside-of-Scope)"],
        },
      ]
    : [
        {
          id: "Scope-1",
          title: "Scope-1",
          colors: ["var(--blue-25)", "var(--blue)"],
        },
        {
          id: "Scope-2",
          title: "Scope-2",
          colors: ["var(--red-25)", "var(--red)"],
        },
        {
          id: "Outside-of-Scope",
          title: "Outside-of-Scope",
          colors: ["var(--Outside-of-Scope-25)", "var(--Outside-of-Scope)"],
        },
      ];

export type EmissionByBusinessCardType = "suborganization" | "site";

interface Props {
  getGroup: (emission: EmissionData) => any;
  groups: any;
  scope?: "Scope-1" | "Scope-2" | "Scope-3" | "Outside-of-Scope";
}

const EmissionByBusinessCard = (props: Props) => {
  const [sort, setSort] = useState<number>(highToLow);
  const [byType, setByType] =
    useState<EmissionByBusinessCardType>("suborganization");
  const { t } = useTranslation([common, overview], { nsMode: "fallback" });

  return (
    <Card variant="outlined" sx={{ borderRadius: "8px", p: "8px" }}>
      <CardContent>
        <Box
          display={"flex"}
          flexWrap={"wrap"}
          justifyContent={"end"}
          mb={"30px"}
          gap={"12px"}
          alignItems={"center"}
        >
          <Typography
            variant="body1"
            flexGrow={1}
            sx={{ width: { xs: "100%", sm: "unset" } }}
          >
            {t("Emissions-by-Business-Structure")}
            <InfoPopper text={t("Emissions-by-Business-Structure-Desc")} />
          </Typography>
          <img src="/img/setting-5.svg" alt="setting" />
          <FormControl variant="standard">
            <Select
              value={sort}
              onChange={(e) => setSort(Number(e.target.value))}
            >
              <MenuItem value={highToLow}>{t("High-to-Low")}</MenuItem>
              <MenuItem value={LowToHigh}>{t("Low-to-High")}</MenuItem>
            </Select>
          </FormControl>

          <FormControl variant="standard" sx={{ width: "160px" }}>
            <Select
              value={byType}
              onChange={(e) =>
                setByType(e.target.value as EmissionByBusinessCardType)
              }
            >
              <MenuItem value={"suborganization"}>{t("By-Sub-Org")}</MenuItem>
              <MenuItem value={"site"}>{t("By-Site")}</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <EmissionByBusinessGroup
          groups={props.groups}
          getGroup={props.getGroup}
          by={byType === "suborganization" ? 2 : 1}
          sort={sort}
          top={5}
          scope={props.scope}
        />
      </CardContent>
    </Card>
  );
};

export default EmissionByBusinessCard;
